import axios from '~/utils/axios';
import { urlWithParams } from '~/utils';
import { Moment } from '~/types';
import { Balance, ReportedBalance } from '~/types/account';

type Response = {
  cursors: {
    next?: string;
  };
  balances?: ReportedBalance[];
};

interface GetReportedBalancesProps {
  bankingDayFrom?: Moment;
  bankingDayTo?: Moment;
  accountId?: string;
  accountNumber?: string;
  profileId?: string;
  balanceCode?: Balance['code'];
  next?: string | null;
  prev?: string;
  limit?: number;
}

export const getReportedBalances = (props: GetReportedBalancesProps) => {
  return axios.get<Response>(
    urlWithParams('/report/balances/search', { limit: 50, ...props }, 'YYYY-MM-DD')
  );
};
